import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Logo = styled.img`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 50px;
  visibility: hidden;

  ${({theme}) =>
    theme.respondTo(
      'md',
      css`
        visibility: visible;
      `
    )};
`;
